import { render, staticRenderFns } from "./User-Dropdown.vue?vue&type=template&id=2d732efc&scoped=true&"
import script from "./User-Dropdown.vue?vue&type=script&lang=js&"
export * from "./User-Dropdown.vue?vue&type=script&lang=js&"
import style0 from "./User-Dropdown.vue?vue&type=style&index=0&id=2d732efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d732efc",
  null
  
)

export default component.exports